module.exports = __webpack_public_path__ + "img/page-04.5b37897a.jpg";